import { ApiOperationData } from "./open-api-import";
import { TreeViewItemModel } from "@genexus/chameleon-controls-library";

export const convertActionToTreeViewItem = (
  operations: ApiOperationData[]
): TreeViewItemModel[] => {
  const treeData: TreeViewItemModel[] = [];
  if (!operations) {
    return treeData;
  }
  operations.forEach(operation => {
    const importCategoryTreeItem: TreeViewItemModel = {
      id: operation.id,
      caption: `${operation.name}`,
      expanded: true,
      leaf: true,
      checkbox: true
    };
    treeData.push(importCategoryTreeItem);
  });
  return treeData;
};
